export const WHATSNEW_ARTICLES_REQUESTED = 'WHATSNEW_ARTICLES_REQUESTED';
export const WHATSNEW_ARTICLES_RESOLVED = 'WHATSNEW_ARTICLES_RESOLVED';
export const WHATSNEW_ARTICLES_ERROR = 'WHATSNEW_ARTICLES_ERROR';
